import React from "react";
import Navbar from "../Components/Navigation/Navbar";
import {Button, Card, Container} from "react-bootstrap";
import Login from "../Components/login/login";

export function loginPage() {
    return (<>
            <Navbar/>
            <Container fluid>
                <Card>
                    <Card.Header>Login</Card.Header>
                    <Card.Body><Login/></Card.Body>
                </Card>
            </Container>
            <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
        </>


    )

}

export default loginPage;